import type { ReactNode } from 'react';

export type Tone = 'green' | 'orange' | 'red' | 'gray';

/** Pastille de statut au style des badges existants. */
export function Tag({
  tone = 'gray',
  children,
  title,
}: {
  tone?: Tone;
  children: ReactNode;
  title?: string;
}) {
  return (
    <span className={`badge badge-${tone}`} title={title}>
      <span className="badge-dot" aria-hidden="true" />
      {children}
    </span>
  );
}
